export default __webpack_public_path__ + "logo-appstore-it-411e72a8307194997c5db0dce2551550.svg";